import React from "react";
// import { Link } from "react-router-dom";
import "./DonationBanner.css";
import { useNavigate } from "react-router-dom";

const DonationBanner = () => {
  const navigate = useNavigate();
  return (
    
    <section className="donation-banner">
      <div className="content">
        <h1>देणगी</h1>
        <p>ग्रंथालयाला आपले साहाय्य करा, आजच देणगी द्या!</p>
      </div>

       <button 
        className="donate-btn"
         onClick={() => navigate("/donation")}
       >
        देणगी द्या
     </button>
    </section>
  );
};

export default DonationBanner;
